import React from 'react';
import ReactDOM from 'react-dom/client';
import './app/css/index.css';
import App from './app/App';
// import reportWebVitals from './reportWebVitals';
import { createBrowserRouter, RouterProvider } from 'react-router-dom'

const router = createBrowserRouter([
  {path: "*", element: <App />}
])

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <RouterProvider router={router} />
  // <Router>
  //   <App />
  // </Router>
)

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    // Retain registration while returning browsers migrate off the old worker.
    navigator.serviceWorker.register('/sw.js', { updateViaCache: 'none' }).catch((err) => {
      // Keep startup resilient if SW registration fails in restricted environments.
      console.warn('Service worker registration failed:', err)
    })
  })
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log)
